export default __webpack_public_path__ + "static/media/News & Announcements.6c6c014d.svg";